export default __webpack_public_path__ + "media/images/list_item-87e85928fe6f0f2da52ca60e0ef14c37.png";